// Machine-readable fields that sit next to the message in payment failures
// (SPEC-077): codes for analytics, and processor_response_text, which is the
// processor's raw wording ("Do Not Honor") — none of them is customer copy.
const NOT_A_MESSAGE = new Set([
  'error_code',
  'errorCode',
  'processor_response_code',
  'processorResponseCode',
  'processor_response_text',
  'processorResponseText',
  'gateway_rejection_reason',
  'gatewayRejectionReason',
  'validation_codes',
  'validationCodes'
])

// Pull the first human-readable string out of a DRF-style error value, which
// may be a string, an array of strings, or a { field: [messages] } map such as
// { email: ['A user is already registered with this e-mail address.'] }.
const firstMessage = (value) => {
  if (!value) return undefined
  if (typeof value === 'string') return value
  if (Array.isArray(value)) return firstMessage(value.find(Boolean))
  if (typeof value === 'object') {
    // Prefer DRF's well-known keys, then fall back to the first field's error.
    const candidates = [
      value.detail,
      value.non_field_errors,
      value.nonFieldErrors,
      value.error,
      ...Object.entries(value)
        .filter(([key]) => !NOT_A_MESSAGE.has(key))
        .map(([, field]) => field)
    ]
    return candidates.map(firstMessage).find(Boolean)
  }
  return undefined
}

// Extract a user-facing message from a fetchHelper failure payload
// ({ value, status }) or a raw response body, falling back to defaultMessage.
const getErrorMessage = (payload, defaultMessage = 'An error occurred.') => {
  if (!payload) return defaultMessage
  // Network-level failures carry a browser exception ("Failed to fetch"),
  // not a server message — always use the fallback copy for those.
  if (payload.isNetworkError) return defaultMessage
  const body = payload.value !== undefined ? payload.value : payload
  return firstMessage(body) || defaultMessage
}

export default getErrorMessage
